<div class="notificacion-detalle-surface">
    <div class="container-fluid">
        <div class="col-12">
            <h5 class="etiquetas text-center">{{notificacion.titulo}}</h5>
        </div>

        <div class="row mt-2">
            <span class="modulo" *ngIf="notificacion.modulo">{{notificacion.modulo}}</span>
            <span class="fecha">{{notificacion.fecha | date:'medium'}}</span>
            <p class="mensaje">{{notificacion.notificacion}}</p>
            <div class="col-12">
                <button mat-flat-button class="ccorbit d-block fw-semibold mt-4" (click)="cerrar()">
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>
